angular.module('impactx.catalog').directive('ixCatalogAutomaticApproval', function () {
    return {
        restrict: 'E',
        require: '^form',
        controller: "CatalogAutomaticApprovalCtrl",
        controllerAs: 'catalogAutomaticApprovalCtrl',
        scope: {},
        bindToController: {
            trns: "=",
            plannedReleaseType: "=",
            plannedReleaseDate: "=",
            isAutoApproval: "=",
            comment: "=",
            minDate: "=",
            dialogData: "="
        },
        templateUrl: 'modules/catalog/templates/catalog-automatic-approval.tmpl.html',
        link: function (scope, element, attributes, formController) {
            scope.formController = formController;
        }
    }
});